import React from "react";
import "./Common_Title.css";

const Common_Title = ({
  titleStart,
  className = "",
}) => {
  return (
    <div className={`common_title ${className}`}>
      <h2 className="main_title">{titleStart} </h2>
    </div>
  );
};

export default Common_Title;
